import { render, staticRenderFns } from "./CaixasManutencao.vue?vue&type=template&id=2f1c677e&scoped=true"
import script from "./CaixasManutencao.vue?vue&type=script&lang=js"
export * from "./CaixasManutencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c677e",
  null
  
)

export default component.exports